import { PermissionsService } from "../../routes/services/permissions.service";
import { TranslatorService } from "../../core/translator/translator.service";
import { StorageService } from "../../routes/services/storage.service";
import { GatewayService } from "../../routes/services/gateway.service";
import { SettingsService } from "../../core/settings/settings.service";
import { NgbModal, NgbModalConfig } from "@ng-bootstrap/ng-bootstrap";
import { GlobalFunction } from "../../routes/services/globalFuntion";
import { FramesService } from "../../routes/services/frames.service";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { FoodsService } from "../../routes/services/foods.service";
import { DietService } from "../../routes/services/diet.service";
import { PondService } from "../../routes/services/pond.service";
import { HelpService } from "../../core/help/help.service";
import { POND } from "../plantings/interfaces";
import { EventEmitter } from "@angular/core";
import * as moment from "moment";
import {
  SimpleChanges,
  TemplateRef,
  Component,
  ViewChild,
  OnInit,
  Output,
  Input
} from "@angular/core";

@Component({
  selector: "app-feed",
  templateUrl: "./feed.component.html",
  styleUrls: ["./feed.component.scss"]
})
export class FeedComponent implements OnInit {
  @ViewChild("modalAlertPlanting") modalAlertPlanting;
  @ViewChild("modalSiembra") modalSiembra;

  @Input() DataPonds: POND | Array<POND> | any;
  @Input() DataForm: any;
  @Input() loading_feed: { url: string; view: boolean } = {
    url: "",
    view: true
  };

  @Output("closedFeed") closedFeeds = new EventEmitter();
  @Output("submitFeed") submitFeed = new EventEmitter();
  @Output("submitHarvest") submitHarvest = new EventEmitter();

  @Input() ButtonClosed: boolean = false;
  @Input() typeView: String = "";
  @Input() default_manual: boolean = false;
  @Input() refresh_value = false;

  @ViewChild("test") public ModalTesting;
  @ViewChild("modalDiet") public ModalDiet;

  FeedForm: FormGroup = new FormGroup({
    kg: new FormControl("", Validators.required),
    diet: new FormControl(""),
    food: new FormControl("", Validators.required),
    planned_end_date: new FormControl("")
  });
  diets = [];
  foods = [];
  @Input() header = true;

  manual: boolean = false;
  is_maintenance: boolean = false;

  kgPond;
  kgHec;

  element: HTMLElement;

  manualDate: any;
  loadingFeeder = false;
  feedPonds = [];
  view_response = false;
  submit_response = false;

  permissions = {
    change_harvest: true,
    change_feed: true
  };

  dataGraph: any = [];
  labelsGraph = ["January", "February", "March", "April", "May", "June"];
  optionsGraph: any;
  selectedDietName: string = "";
  dietsLoaded = false;
  foodsLoaded = false;

  constructor(
    public permissionsService: PermissionsService,
    public translatorService: TranslatorService,
    public PostFeedsService: GatewayService,
    public settingService: SettingsService,
    public storageService: StorageService,
    public GlobalFunction: GlobalFunction,
    public frameService: FramesService,
    public FoodsService: FoodsService,
    public DietService: DietService,
    public helpService: HelpService,
    public dietService: DietService,
    public pondService: PondService,
    private modalService: NgbModal,
    config: NgbModalConfig
  ) {
    config.backdrop = "static";
    config.keyboard = false;
    config.size = "xl";
    config.centered = true;
    config.animation = false;
  }
  food_selected: any = null;

  ngOnChanges(changes: SimpleChanges) {
    console.log(changes);

    if (
      changes["loading_feed"] &&
      changes["loading_feed"].currentValue &&
      changes["loading_feed"].currentValue.view
    ) {
      this.manual = false;
      this.is_maintenance = false;
    }

    if (changes["default_manual"]) {
      this.manual = changes["default_manual"].currentValue;
    }
    if (changes["DataForm"]) {
      this.FeedForm.setValue({
        ...this.FeedForm.value,
        ...changes["DataForm"].currentValue
      });
      this.kgPond = Number(changes["DataForm"].currentValue.kg);

      if (changes["DataForm"].currentValue.food) {
        this.select_food(changes["DataForm"].currentValue.food);
      }
    }

    if (changes["DataPonds"]) {
      this.DataPonds = changes["DataPonds"].currentValue;
    }

    this.calculateKgHA(this.DataPonds, 1);
    this.syncRationControlsState();
  }

  /**
   * Habilita o deshabilita el FormControl de dieta segun `canSendRation()`.
   * Kg y alimento siempre quedan habilitados: el cliente puede mandar una
   * racion manual aunque el estanque sea manejado por administracion, solo
   * la dieta preestablecida es exclusiva del admin en ese caso. El atributo
   * `[disabled]` del template no alcanza aqui: al tener `formControlName`,
   * Angular lo ignora y solo respeta el estado del propio `FormControl`.
   * @returns void
   */
  private syncRationControlsState(): void {
    const control = this.FeedForm.get("diet");
    if (!control) {
      return;
    }
    const canSend = this.canSendRation();
    if (canSend && control.disabled) {
      control.enable({ emitEvent: false });
    } else if (!canSend && control.enabled) {
      control.disable({ emitEvent: false });
    }
  }
  ngAfterContentInit(): void {
    let inputs1 = <HTMLInputElement>document.getElementById("food_feed");
    let inputs2 = <HTMLInputElement>document.getElementById("diet_feed");
    if (inputs1 && inputs2) {
      inputs1.addEventListener("keydown", (event: any) => {
        event.preventDefault();
      });

      inputs2.addEventListener("keydown", (event: any) => {
        event.preventDefault();
      });
    }
  }
  ngOnInit(): void {
    const validate_subclient = (prop) => {
      return this.permissionsService.validatePermissionsExistSubclient(prop);
    };

    const keys_validate_subclient = ["change_harvest", "change_feed"];

    keys_validate_subclient.forEach((key) => {
      this.permissions[key] = validate_subclient(key);
    });

    if (this.storageService.localValue) {
      const personal_web = this.storageService.localValue;
      this.DietService.getDiets("").subscribe(
        (resp) => {
          this.diets = resp;
          this.dietsLoaded = true;
        },
        () => {
          this.dietsLoaded = true;
        }
      );
      const { farm_id } = personal_web;

      const queryFarm = farm_id ? `?linked_farm=${farm_id}` : "";
      this.FoodsService.getFoods(queryFarm).subscribe(
        (resp) => {
          this.foods = resp;
          this.foodsLoaded = true;
          const foodId = this.FeedForm.value && this.FeedForm.value.food;
          if (foodId) {
            this.select_food(foodId);
          }
        },
        () => {
          this.foodsLoaded = true;
        }
      );
    }

    if (this.helpService.activeTutorial) {
      const content = [
        {
          element: "#manual_feed",
          title: "Alimentar manualmente",
          intro:
            "Eso es por si los alimentadores no tienen conexión con los servidores, y no se pierda la información.",
          position: "top"
        },
        {
          element: "#kg_feed",
          title: "Kilogramos a alimentar",
          intro:
            "Puedes indicar cuandos kg serán por el estanque(Ambos datos son intercambiables).",
          position: "top"
        },
        {
          element: "#kgHec",
          title: "Kilogramos a alimentar",
          intro:
            "O si lo prefieres indica cuandos kg serán por la hectarea (Ambos datos son intercambiables).",
          position: "top"
        },
        {
          element: "#diet_feed",
          title: "Dieta",
          intro:
            "Las dietas indican la forma en la que se distriburá el alimento, a lo largo del día.",
          position: "top"
        },
        {
          element: "#food_feed",
          title: "Alimento",
          intro: "El alimento que se le dará al estanque y que está depositado en la tolva.",
          position: "top"
        },
        {
          element: "#refeed_feed",
          title: "Reenviar racion",
          intro: "Envía la ultima configuración registrada.",
          position: "bottom"
        },
        {
          element: "#test_feed",
          title: "Test",
          intro: "Verifica si hay conectividad con la alimentadora.",
          position: "bottom"
        },
        {
          element: "#send_feed",
          title: "Enviar racion",
          intro: "Finaliza el proceso y envía la configuración de racion que haz realizado.",
          position: "bottom"
        }
      ];

      this.helpService.runOther(content, true);
    }
  }

  plantingSelected;

  type = "";

  closedClick() {
    this.closedFeeds.emit("");
  }

  changeManual() {
    this.manual = true;
    this.is_maintenance = false;
    this.FeedForm.setValue({
      ...this.FeedForm.value,
      diet: "",
      kg: 0
    });

    this.kgPond = 0;
    this.kgHec = 0;
    // this.manual = !this.manual;
  }

  textPonds(value) {
    let text = "";
    if (value) {
      if (value.name) {
        text = value.name;
      } else if (value.length > 0) {
        let array = value.map((resp) => resp.name);
        text = array.toString();
      } else if (value.length === 0) {
        text = "";
      }
    }
    return text;
  }

  decimalFilter(event: any) {
    const reg = /^-?\d*(\.\d{0,2})?$/;
    let input = event.target.value + String.fromCharCode(event.charCode);

    if (!reg.test(input)) {
      event.preventDefault();
    }
  }

  calculateKgHA(ponds, type) {
    if (ponds.length > 0) {
      if (type === 2) {
        /* Kilogramos por estanque  */
        this.kgPond = this.kgHec * ponds[0].hectares;
        this.kgPond = this.kgPond.toFixed(2);
      } else {
        /* Kilogramos por hectarea */
        this.kgHec = this.kgPond / ponds[0].hectares;
        this.kgHec = this.kgHec.toFixed(2);
      }
    }
  }

  validatePonds(kgha, ponds) {
    if (ponds) {
      if (ponds.length > 1) {
        return this.translatorService.translate("general.undefined");
      } else {
        return ponds.length === 1
          ? Number(kgha) / ponds[0].hectares
          : this.translatorService.translate("general.select-pond");
      }
    }
  }

  Modal = async (template: TemplateRef<any>, type) => {
    switch (type) {
      case "show":
        const ref = await this.modalService.open(template);
        await ref.shown.subscribe();
        break;
      case "hide":
        this.modalService.dismissAll(``);

        break;
      default:
    }
  };

  textError(e) {
    let { error, statusText } = e;
    let arrayErrors: Array<any> = error ? Object.values(error) : [];
    for (let i = 0; i < arrayErrors.length; i++) {
      if (arrayErrors[i] === true) {
        return `${statusText.toString()}`;
      } else {
        return `${arrayErrors[i].toString()}`;
      }
    }
  }
  /*
  validateButtonDisabled() {
    try {
      const length = this.DataPonds && this.DataPonds.length > 0;
      if (length && this.DataPonds[0].planting) {
        let pond = this.DataPonds[0];
        let fecha1 = moment(new Date());
        let fecha2 = moment(
          `${pond.planting.planned_end_date}T10:00:00.112276-07:00`
        );

        let days = fecha2.diff(fecha1, "days");
        if (!pond.planting) {
          return true;
        }
        if (pond.is_done) {
          return true;
        }
        if (!pond.planting.planned_end_date && !pond.is_done) {
          return false;
        }

        if (days >= 0 && !pond.is_done) {
          return false;
        }
        if (days < 0 && !pond.is_done) {
          return true;
        }
      }
      if (length && !this.DataPonds[0].planting) {
        return true;
      }
    } catch (error) {
      return false;
    }
  } */

  checkKey(e: any) {
    e.preventDefault();
    let array = ["kgPond", "kgHec", "kg_feed", "diet_feed", "food_feed"];
    const validate = (key) => {
      let index = array.findIndex((item) => e.target.id === item);
      if (key === 39) {
        let next = array[index + 1];
        if (this.DataPonds.length === 1 && next === "kg_feed") {
          next = "diet_feed";
        }
        if (!next) {
          next = "kgPond";
        }

        let nu: any = <HTMLInputElement>document.getElementById(next);
        nu.focus();
      }
      if (key === 37) {
        let previus = array[index - 1];
        if (this.DataPonds.length === 1 && previus === "kg_feed") {
          previus = "kgHec";
        }
        if (!previus) {
          previus = "food_feed";
        }
        let nu: any = <HTMLInputElement>document.getElementById(previus);
        nu.focus();
      }
    };
    // up arrow
    if (e.keyCode == "38") {
      validate(37);
    }
    // down arrow
    if (e.keyCode == "40") {
      validate(39);
    }
  }
  status_server = "";
  viewModalResponse = (status: "done" | "loading" | "error") => {
    if (!this.view_response) {
      return;
    }

    const ponds = Array.isArray(this.DataPonds) ? this.DataPonds : [];

    this.DataPonds = ponds.map((pond) => {
      const linkedFeeders = Array.isArray(pond.linked_feeders) ? pond.linked_feeders : [];
      const feeders_on = linkedFeeders.filter(
        (feeder) => feeder.status_power && !feeder.alert_comm
      );

      return {
        ...pond,
        linked_feeders: feeders_on.map((feeder) => {
          return {
            ...feeder,
            status_refeed: {
              server: status,
              feeder_status: "loading",
              ration_status: "loading"
            }
          };
        })
      };
    });

    this.submit_response = true;
    this.status_server = status;
  };
  mode_test = false;

  /**
   * Indica si se puede mostrar el boton de envio de racion.
   * Los estanques con feeding_by_admin en true los alimenta administracion desde
   * su propio apartado, por lo que el cliente no debe poder enviarles racion.
   * El administrador si puede, aunque este operando en modo cliente.
   * Con varios estanques seleccionados basta con que uno sea manejado por
   * administracion para ocultarlo, porque el envio es una sola operacion.
   * @returns true cuando el envio esta permitido para el usuario actual.
   */
  canSendRation(): boolean {
    if (this.storageService.validateSoloAdmin()) {
      return true;
    }

    const ponds = Array.isArray(this.DataPonds) ? this.DataPonds : [this.DataPonds];
    return !ponds.some((pond: any) => pond && pond.feeding_by_admin);
  }

  /**
   * Resuelve el id de la dieta de administracion a aplicar cuando el cliente
   * envia racion manual sobre un estanque manejado por administracion (dieta
   * bloqueada en el select, ver canSendRation()/syncRationControlsState()). Se
   * toma del ultimo envio registrado en el estanque (Pond.last_ration.diet),
   * consultado directo al backend para no depender de que el pond recibido
   * por @Input ya la traiga.
   * @returns Id de la dieta de administracion, o null si no hay una registrada.
   */
  private async getAdminDietId(): Promise<number | null> {
    const ponds = Array.isArray(this.DataPonds) ? this.DataPonds : [this.DataPonds];
    const adminPond = ponds.find((pond: any) => pond && pond.feeding_by_admin);
    if (!adminPond) {
      return null;
    }
    try {
      const pond = await this.pondService
        .getPonds("?fields=id,last_ration", adminPond.id)
        .toPromise();
      return pond && pond.last_ration && pond.last_ration.diet ? pond.last_ration.diet.id : null;
    } catch (error) {
      return null;
    }
  }

  /**
   * Registra el envio de racion: manual (por estanque, sin dieta) o normal
   * (un solo frame para todos los estanques seleccionados). En el caso
   * normal, si el estanque es manejado por administracion, la dieta no sale
   * del select (deshabilitado) sino de `getAdminDietId()`.
   * @returns void
   */
  async register() {
    this.mode_test = true;
    const value = this.FeedForm.value;
    this.viewModalResponse("loading");
    this.loadingFeeder = true;
    if (this.manual) {
      this.DataPonds.forEach((item) => {
        let obj = {
          food: Number(value.food),
          kgs_fed: Number(value.kg),
          pond: item.id,
          created_date: this.manualDate,
          is_maintenance: false
        };

        this.PostFeedsService.postManualFeed(obj).subscribe(
          (resp) => {
            this.viewModalResponse("done");
            this.loadingFeeder = false;
          },
          (err) => {
            this.viewModalResponse("error");
            this.loadingFeeder = false;
          }
        );
      });
    } else {
      const dietId = this.canSendRation() ? Number(value.diet) : await this.getAdminDietId();
      let obj = {
        diet: dietId,
        food: Number(value.food),
        kge: Number(value.kg),
        ponds: this.DataPonds.map((item) => {
          return item.id;
        }),
        datetime: moment().format(),
        is_maintenance: this.is_maintenance
      };

      this.PostFeedsService.sendFeedFrame(obj).subscribe(
        (resp) => {
          this.submitFeed.emit(this.DataPonds);
          this.viewModalResponse("done");

          this.feedPonds = this.DataPonds;
          this.loadingFeeder = false;
        },
        (err) => {
          this.loadingFeeder = false;
          this.viewModalResponse("error");
        }
      );
    }
  }
  refeed = async () => {
    const item = this.DataPonds;

    let array = item.map((item) => {
      return item.id;
    });
    this.viewModalResponse("loading");
    this.frameService.refeed({ ponds: array }).subscribe(
      (resp) => {
        this.GlobalFunction.animation("success", "Se ha reenviado la ración", "Correctamente");
        this.submitFeed.emit(this.DataPonds);
        this.viewModalResponse("done");
      },
      (err) => {
        this.viewModalResponse("error");
      }
    );
  };
  testStatus = () => {
    this.mode_test = false;
    this.viewModalResponse("loading");
    const ponds_id = this.DataPonds.map((item) => item.id);

    if (ponds_id.length > 0) {
      this.frameService.Frame("status", `?pond_id=${ponds_id}`).subscribe((item) => {
        this.viewModalResponse("done");
      });
    }
  };

  closedTest(event) {
    this.submit_response = event;
    this.status_server = "";

    this.DataPonds = this.DataPonds.map((pond) => {
      return {
        ...pond,
        linked_feeders: pond.linked_feeders.map((feeder) => {
          return {
            ...feeder,
            status_refeed: {
              server: "",
              feeder_status: "",
              ration_status: ""
            }
          };
        })
      };
    });
  }
  submitHarvests = (event) => {
    this.modalService.dismissAll(``);
    this.submitHarvest.emit(event);
  };

  dietID: any;
  setData() {
    const diet = this.FeedForm.value.diet;
    this.dietID = diet;
    if (diet) {
      this.dietService.getDiet(diet).subscribe((resp) => {
        this.selectedDietName = resp.name || "";
        const { labels, data, options } = this.constructDataGraph(resp);

        this.labelsGraph = labels;
        this.dataGraph = data;
        this.optionsGraph = options;
        this.Modal(this.ModalDiet, "show");
      });
    }
  }

  constructDataGraph(value) {
    const Labels = Array.from({ length: 24 }, (_, i) => `${i}:00`);

    const percentages = value.percentages.map((item) => Number(item) * 100);
    const all_grams = value.percentages.map((item) => (Number(item) * this.kgPond).toFixed(2));

    const Data = [
      {
        data: percentages,
        name: "Porcentaje",
        type: "bar",
        color: "#30646c",
        yAxisIndex: 0
      },
      {
        data: all_grams,
        name: "Kilogramos a alimentar",
        type: "line",
        color: "#1e983b",
        yAxisIndex: 1,
        smooth: true
      }
    ];

    return {
      labels: Labels,
      data: Data,
      options: {
        legend: {
          data: ["Porcentaje", "Kilogramos a alimentar"],
          top: 0
        },
        tooltip: {
          trigger: "axis",
          formatter: (params) => {
            const index = params[0]?.dataIndex ?? 0;
            const interval = value.intervals?.[index] ?? "N/A";
            const amount_shoots = 60 / interval;

            const porcentaje = params.find((p) => p.seriesName === "Porcentaje")?.data.toFixed(2);

            const kilograms = params.find((p) => p.seriesName === "Kilogramos a alimentar")?.data;

            return `
            Hora: <b>${Labels[index]}</b><br/>
            Porcentaje: <b>${porcentaje}%</b><br/>
            Kilogramos: <b>${kilograms} kg</b><br/>
            Intervalo entre disparo: <b>${interval}</b><br/>
            Cantidad de disparos: <b>${amount_shoots}</b>
          `;
          }
        },
        xAxis: {
          type: "category",
          data: Labels,
          axisPointer: { type: "shadow" }
        },
        yAxis: [
          {
            type: "value",
            name: "Porcentaje",
            min: 0,
            axisLabel: { formatter: "{value} %" }
          },
          {
            type: "value",
            name: "Kilogramos a alimentar",
            position: "right",
            min: 0,
            axisLabel: { formatter: "{value} " }
          }
        ],
        series: Data
      }
    };
  }

  select_food = (id) => {
    this.food_selected = this.foods.find((item: any) => Number(item.id) === Number(id));
  };

  get feedReady(): boolean {
    return this.dietsLoaded && this.foodsLoaded;
  }

  validatingAdmin() {
    if (this.GlobalFunction.validateSoloAdmin()) {
      return true;
    }
    if (this.dietID == 1366) {
      return false;
    }
    return true;
  }
}
